function modifyLink(link) {
    if (link.tagName !== 'A') return;

    const url = new URL(link.href);
    if (!url.searchParams.has("filter.v.availability")) {
        url.searchParams.append("filter.v.availability", "1");
        link.href = url.href;
    }
}

function setAvailabilityFilterInCollectionLinks() {
    const selectorStr = "header a[href*='/collections/'], .drawer a[href*='/collections/']"; // you can change this selector based on your theme structure
    selectorStr.split(',').forEach((selector) => {
        const selectorTrimmed = selector.trim();
        if (selectorTrimmed) {
            document.querySelectorAll(selectorTrimmed).forEach(modifyLink);
        }
    });
}

const applyAutoFilterLogic = () => {
    // Auto filter when click size
    setInterval(()=>{
        document.querySelectorAll('input[name="filter.v.option.talla"]').forEach(el => {
          if (!el.classList.contains('e1active')) {
            el.classList.add('e1active');
              el.addEventListener('change', () => {
              let status = checkSelectSize()
              document.querySelector('input[name="filter.v.availability"]').checked = !status;
            })
          }
        })
    },100);
}

const checkSelectSize = () => {
    let isSelected = true
    document.querySelectorAll('input[name="filter.v.option.talla"]').forEach(el => {
        if(el.checked == true) {
            isSelected = false
        }
    });
    return isSelected
}

document.addEventListener("DOMContentLoaded", () => {
    //setAvailabilityFilterInCollectionLinks();
    applyAutoFilterLogic();
});